export default "__VITE_ASSET__24edb397__"